export const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date.getTime());
};
export const initDateFormatter = (locales) => {
    const formattersLocale = locales || navigator.languages;
    const formatters = {
        dateShort: new Intl.DateTimeFormat(formattersLocale, {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
        }),
        hour12: new Intl.DateTimeFormat(formattersLocale, {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        }),
        monthDayLong: new Intl.DateTimeFormat(formattersLocale, {
            weekday: "long",
            month: "long",
            day: "2-digit",
        }),
        monthDayShort: new Intl.DateTimeFormat(formattersLocale, {
            month: "short",
            day: "2-digit",
        }),
        timeShort: new Intl.DateTimeFormat(formattersLocale, {
            timeStyle: "short",
        }),
    };
    const formatDateShort = (date) => {
        return formatters.dateShort.format(date);
    };
    const formatHour12 = (date) => {
        return formatters.hour12.format(date);
    };
    const formatMonthDayLong = (date) => {
        return formatters.monthDayLong.format(date);
    };
    const formatMonthDayShort = (date) => {
        return formatters.monthDayShort.format(date);
    };
    const formatTimeShort = (date) => {
        return formatters.timeShort.format(date);
    };
    const dateFormatter = (dateTime) => {
        const parsedDate = new Date(Date.parse(dateTime));
        return isValidDate(parsedDate)
            ? {
                dateShort: formatDateShort(parsedDate),
                hour12: formatHour12(parsedDate),
                monthDayLong: formatMonthDayLong(parsedDate),
                monthDayShort: formatMonthDayShort(parsedDate),
                timeShort: formatTimeShort(parsedDate),
            }
            : {
                dateShort: dateTime,
                hour12: dateTime,
                monthDayLong: dateTime,
                monthDayShort: dateTime,
                timeShort: dateTime,
            };
    };
    return {
        dateFormatter,
        formatters,
        formatDateShort,
        formatHour12,
        formatMonthDayLong,
        formatMonthDayShort,
        formatTimeShort,
    };
};
export default initDateFormatter;
